export const ITEM_LEAD_TIME_AVAILABLE_NOW = 'available-now';

export const NEW_SELLER_SINCE_THRESHOLD = 6;
